// import core & vendor packages below
import { useDispatch } from 'react-redux';
import { useState, useEffect } from 'react';

// import components below
import PatientTable from './components/Table';
import ModalDietType from './components/DietType';
import { getPatients } from 'reducers/patientReducer';
import SearchPatientFilter from './components/Filter';
import FormPatientProfile from './components/FormPatientProfile';

// main component
const SearchPatient = () => {
  const [state, setState] = useState([]);
  const dispatch = useDispatch();

  const [showProfile, setShowProfile] = useState({
    isShowView: false,
    profileId: null,
    dietType: false,
  });

  useEffect(() => {
    // eslint-disable-next-line camelcase
    dispatch(getPatients({ patient_status: 'admitted' }));
  }, []);

  return (
    <div>
      {!showProfile.isShowView ? (
        <div className='searchPatient'>
          <SearchPatientFilter setState={setState} />

          <PatientTable state={state} setState={setState} setShowProfile={setShowProfile} />
        </div>
      ) : (
        <FormPatientProfile showProfile={showProfile} setShowProfile={setShowProfile} />
      )}

      <ModalDietType showProfile={showProfile} setShowProfile={setShowProfile} />
    </div>
  );
};

export default SearchPatient;
